import { render } from "./screen_padmounts.vue?vue&type=template&id=879fb20c"
import script from "./screen_padmounts.vue?vue&type=script&lang=js"
export * from "./screen_padmounts.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployer/asset-portal/releases/20260828153143/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__